import styled from "styled-components";

export const PinnedTabsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px 0;
    width: 100%;
`;

export const PinnedTabItem = styled.div<{ $isActive: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    height: 105px;
    width: 44px;
    list-style-type:none;
    padding: 0 8px;
    border-radius: 6px;
    outline:1px solid green;
    background-color: ${({ $isActive }) =>
        $isActive ? "rgba(124, 190, 123, 0.25)" : "transparent"};
    border-left: 3px solid
        ${({ $isActive }) => ($isActive ? "rgb(124, 190, 123)" : "transparent")};
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    transition:
        width 0.25s ease,
        background-color 0.2s ease,
        box-shadow 0.25s ease;
    z-index: 1000;

    &:hover {

        background-color: ${({ $isActive }) =>
            $isActive
                ? "rgba(124, 190, 123, 0.35)"
                : "rgba(255, 255, 255, 0.08)"};
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.35);
        z-index: 2000;
    }
`;

export const PinnedTabName = styled.span`
    font-size: 15px;
    color: black;
    writing-mode: vertical-rl;
    text-orientation: upright;
    overflow: hidden;
    text-overflow: clip;
    user-select: none;
    z-index: 10000;
    ${PinnedTabItem}:hover & {
        text-overflow: ellipsis;
    }
`;


